var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('span',{staticClass:"page-title",on:{"click":_vm.onClickReport}},[_vm._v(" 말씀해 주신 의견은 최대한 반영해 "),_c('br'),_vm._v(" 빠르게 처리할 수 있도록 할게요 :) ")]),_c('span',{staticClass:"page-report-title"},[_vm._v("건의 & 불편사항 신고")]),_c('UpdateBox',{attrs:{"title":"업데이트 내용","updateItems":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }